import React from 'react';
import siteContent from '../../data/siteContent';

function FinalCtaSection() {
  const link = `https://wa.me/${siteContent.whatsapp.number}?text=${encodeURIComponent(siteContent.whatsapp.budgetMessage)}`;

  return (
    <section className="cta-band">
      <h2 className="reveal">
        {siteContent.cta.title} <em>{siteContent.cta.titleAccent}</em>
      </h2>
      <p className="reveal">{siteContent.cta.subtitle}</p>

      <div className="hero-cta reveal">
        {/* <a href={link} className="btn-primary" target="_blank" rel="noreferrer">
          Falar com a equipe
        </a> */}
      </div>
    </section>
  );
}

export default FinalCtaSection;